<span class="tw-relative tw-inline-flex" [class.tw-hidden]="isCypressTest">
  <button
    type="button"
    class="notif-bell"
    [attr.aria-label]="t('notifications.title', 'Notifications')"
    [class.tw-ring-2]="counter() > 0"
    [class.tw-ring-amber-600]="counter() > 0"
    [class.!tw-bg-muted]="isOpen()"
    (click)="toggle()"
  >
    <i class="fa fa-bell-o tw-text-lg tw-font-semibold"></i>
    @if (counter() > 0) {
      <span class="tw-font-text tw-absolute -tw-bottom-2 -tw-right-2 tw-flex">
        @if (pingCounter()) {
          <div
            class="tw-absolute tw-inset-0 tw-size-4 tw-animate-ping tw-rounded-full tw-bg-amber-600 tw-text-[0] tw-transition-all"
          ></div>
        }
        <span
          class="tw-relative tw-inline-flex tw-size-4 tw-items-center tw-justify-center tw-rounded-full tw-bg-amber-600 tw-text-xs tw-text-white"
        >
          {{ counter() }}
        </span>
      </span>
    }
  </button>
</span>

@if (isOpen()) {
  <div
    class="notif-overlay"
    [class.notif-overlay--closing]="isClosing()"
    [class.notif-dark]="isDarkTheme()"
  >
    <div class="notif-backdrop" (click)="close()"></div>

    <aside class="notif-panel" [class.notif-panel--closing]="isClosing()">
      <header class="notif-header">
        <div class="notif-header__left">
          <h1 class="notif-header__title" (click)="backToList()">
            {{ t("notifications.title", "Notifications") }}
          </h1>
          @if (counter() > 0) {
            <span class="notif-counter-badge">{{ counter() }}</span>
          }
        </div>
        <button
          type="button"
          (click)="close()"
          [attr.aria-label]="t('notifications.close', 'Close notifications')"
          class="notif-close"
        >
          <i class="ft-x"></i>
        </button>
      </header>

      <nav class="notif-tabs">
        <button
          type="button"
          class="notif-tab"
          [class.notif-tab--active]="listView() === 'new'"
          (click)="setCurrentList('new')"
        >
          {{ t("notifications.tabNew", "New") }}
          @if (counter() > 0) {
            <span class="notif-tab__count">{{ counter() }}</span>
          }
        </button>
        <button
          type="button"
          class="notif-tab"
          [class.notif-tab--active]="listView() === 'archived'"
          (click)="setCurrentList('archived')"
          [disabled]="archivedCount() === 0"
        >
          {{ t("notifications.tabArchived", "Archived") }}
        </button>
      </nav>

      <div #scrollContainerRef class="notif-body">
        <div
          class="notif-slider"
          [class.notif-slider--detail]="currentView() === 'item'"
        >
          <div class="notif-slide">
            @if ((currentViewNotificationsList$() | async)?.length > 0) {
              <ul class="notif-list">
                @for (
                  notification of currentViewNotificationsList$() | async;
                  track notification._id
                ) {
                  <li>
                    <button
                      class="notif-item"
                      [class.notif-item--unread]="!notification?.viewed_date"
                      (click)="viewNotification(notification)"
                    >
                      <div
                        class="notif-item__icon"
                        [class.notif-item__icon--unread]="
                          !notification?.viewed_date
                        "
                        [class.notif-item__icon--read]="
                          notification?.viewed_date
                        "
                      >
                        @if (!notification?.viewed_date) {
                          <i class="fa fa-bell-o"></i>
                        } @else {
                          <i class="ft-check"></i>
                        }
                      </div>

                      <div class="notif-item__content">
                        <h3 class="notif-item__title">
                          {{ notification?.title }}
                        </h3>
                        <p class="notif-item__summary">
                          {{ notification?.summary }}
                        </p>
                        <div class="notif-item__meta">
                          <span class="notif-item__date">
                            <i class="ft-calendar"></i>
                            {{ notification?.active_date | date: "mediumDate" }}
                          </span>
                          @if (notification?.expired) {
                            <span class="notif-item__expired">{{
                              t("notifications.expired", "Expired")
                            }}</span>
                          }
                          @if (
                            notification?.viewed_date && listView() === "archived"
                          ) {
                            <span class="notif-item__read-date">
                              {{ t("notifications.read", "Read") }}
                              {{
                                notification?.viewed_date | date: "mediumDate"
                              }}
                            </span>
                          }
                        </div>
                      </div>

                      <i class="ft-chevron-right notif-item__chevron"></i>
                    </button>
                  </li>
                }
              </ul>
            }

            <div class="notif-empty">
              @if (listView() === "new") {
                @if (counter() > 0) {
                  <p class="notif-empty__text">
                    {{
                      t(
                        "notifications.allUnreadDone",
                        "That's all your unread notifications."
                      )
                    }}
                  </p>
                  <p class="notif-empty__sub">
                    {{
                      t(
                        "notifications.markReminder",
                        "Please ensure to read and mark them as viewed."
                      )
                    }}
                  </p>
                } @else {
                  <div class="notif-empty__icon-wrap">
                    <i class="ft ft-check-circle"></i>
                  </div>
                  <p class="notif-empty__title">
                    {{ t("notifications.allCaughtUp", "All caught up") }}
                  </p>
                  <p class="notif-empty__sub">
                    {{
                      t(
                        "notifications.noUnread",
                        "You have no unread notifications."
                      )
                    }}
                  </p>
                }
              }
              @if (listView() === "archived") {
                <p class="notif-empty__text">
                  {{
                    t(
                      "notifications.allArchivedDone",
                      "That's all your archived notifications."
                    )
                  }}
                </p>
              }
            </div>
          </div>

          <div class="notif-slide">
            <div class="notif-detail">
              <button
                (click)="backToList()"
                class="notif-detail__back"
                type="button"
                [disabled]="currentView() === 'list'"
              >
                <i class="ft-chevron-left"></i>
                {{ t("notifications.backToList", "Back to list") }}
              </button>

              <div class="notif-detail__card">
                <div class="notif-detail__card-header">
                  <h2 class="notif-detail__title">
                    {{ selectedNotification()?.title }}
                  </h2>
                  <div class="notif-detail__badges">
                    <span class="notif-detail__date-badge">
                      <i class="ft-calendar"></i>
                      {{
                        selectedNotification()?.active_date | date: "mediumDate"
                      }}
                    </span>
                    @if (!selectedNotification()?.viewed_date) {
                      <span
                        class="notif-detail__status-badge notif-detail__status-badge--unread"
                        >{{ t("notifications.unread", "Unread") }}</span
                      >
                    } @else {
                      <span
                        class="notif-detail__status-badge notif-detail__status-badge--read"
                        >{{ t("notifications.read", "Read") }}</span
                      >
                    }
                  </div>
                </div>

                <div
                  class="notif-detail__body tw-prose tw-prose-sm"
                  [innerHTML]="selectedNotification()?.body"
                  [class.tw-prose-invert]="isDarkTheme()"
                ></div>
              </div>

              <div class="notif-detail__actions">
                @if (!selectedNotification()?.viewed_date) {
                  <button
                    class="notif-detail__mark-btn"
                    type="button"
                    [disabled]="currentView() === 'list' || isLoading()"
                    (click)="markNotificationAsViewed()"
                    [class.notif-detail__mark-btn--loading]="isLoading()"
                  >
                    <span [class.tw-invisible]="isLoading()">
                      <i class="ft-check"></i>
                      {{ t("notifications.markAsRead", "Mark as read") }}
                    </span>
                    @if (isLoading()) {
                      <span class="notif-detail__spinner">
                        <i class="ft-loader tw-animate-spin"></i>
                      </span>
                    }
                  </button>
                }
                @if (selectedNotification()?.viewed_date) {
                  <div class="notif-detail__read-info">
                    <i class="ft-check-circle"></i>
                    {{ t("notifications.markedReadOn", "Marked as read on") }}
                    {{ selectedNotification()?.viewed_date | date: "medium" }}
                  </div>
                }
                @if (selectedNotification()?.expired) {
                  <div class="notif-detail__expired-info">
                    <i class="ft-alert-triangle"></i>
                    {{ t("notifications.expiredOn", "Expired on") }}
                    {{ selectedNotification()?.expiry_date | date: "mediumDate" }}
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </aside>
  </div>
}
